import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Slide from '@mui/material/Slide';
import PropTypes from 'prop-types';
import { CloseIcon } from '../../../assets/CommonSvg';
import { Accordion, AccordionDetails, AccordionSummary, Divider } from '@mui/material';
import { DownIcon } from '../../../../assets/common-svg/CommonSvg';
import ReactQuill from 'react-quill';
import NoDataCard from '../../../../components/no-data-card';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: 300, sm: 400, md: 500, lg: 951 },
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: "10px",
    py: "15px",
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column',
}

const contentStyle = {
    overflowY: 'auto',
    padding: '0 24px 24px',
    flex: 1,
}

const AccordianModal = ({ open, setOpen, ModalTitle, data }) => {
    const handleClose = () => {
        setOpen(false);
    }

    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open || false}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={open}>
                    <Slide direction='left' in={open} mountOnEnter unmountOnExit >
                        <div className='relative h-full w-full'>
                            <Box sx={style} className="relative" >
                                <div
                                    onClick={handleClose}
                                    className="absolute right-0 1sm:right-[-30px] top-[-30px] cursor-pointer"
                                >
                                    <Tooltip title="close">
                                        <div>
                                            <CloseIcon fill={'White'} />
                                        </div>
                                    </Tooltip>
                                </div>
                                {ModalTitle &&
                                    <div className='pb-[10px] border-b border-[#DDDDDD]'>
                                        <Typography id="transition-modal-title" variant="h6" textAlign={'center'} component="h6">
                                            {ModalTitle}
                                        </Typography>
                                    </div>}

                                <div style={contentStyle}>
                                    <div className="mt-3 bg-white flex flex-col gap-4">
                                        {data.length > 0 ?
                                            data?.map((section) => (
                                                <div key={section.slug} className="section-container">
                                                    <Typography variant='h5' className='pb-2 text-center '>
                                                        {section?.slug
                                                            .split('-')
                                                            .map(word =>
                                                                word?.toLowerCase() === 'bmr'
                                                                    ? 'BMR'
                                                                    : word?.charAt(0)?.toUpperCase() + word.slice(1)
                                                            )
                                                            .join(' ')
                                                        }
                                                    </Typography>
                                                    {section?.data?.length>= 0?
                                                    section?.data?.map((item, index) => (
                                                        <Accordion
                                                            key={item.id}
                                                            defaultExpanded={index == 0}
                                                            className='accordian-cards'
                                                            style={{
                                                                backgroundColor: '#F0F1F5',
                                                                boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px',
                                                                borderRadius: '10px',
                                                                marginBottom: '16px'
                                                            }}
                                                        >
                                                            <AccordionSummary
                                                                expandIcon={<DownIcon />}
                                                                aria-controls={`panel-${section.slug}-${index}-content`}
                                                                id={`panel-${section.slug}-${index}-header`}
                                                                className='faq-title'
                                                            >
                                                                <div className='flex justify-between'>
                                                                    <Typography variant="h6">{item.title}</Typography>
                                                                </div>
                                                            </AccordionSummary>
                                                            <AccordionDetails className='p-0'>
                                                                <Divider />

                                                                <div className='hide-editable p-2'>
                                                                    <ReactQuill
                                                                        theme="snow"
                                                                        value={item.content}
                                                                        readOnly
                                                                        modules={{
                                                                            toolbar: false
                                                                        }}
                                                                    />
                                                                </div>
                                                            </AccordionDetails>
                                                        </Accordion>
                                                    ))
                                                    :<div className="mt-4">
                                                    <NoDataCard/>
                                                </div>}
                                                </div>
                                            ))

                                            : <div className="mt-4">
                                                <NoDataCard />
                                            </div>}
                                    </div>
                                </div>

                            </Box>
                        </div>
                    </Slide>
                </Fade>
            </Modal>
        </div>
    );
}

AccordianModal.propTypes = {
    open: PropTypes.bool,
    setOpen: PropTypes.func,
    ModalTitle: PropTypes.string,
    data: PropTypes.func
}

export default AccordianModal